/**
 * Created by AlexanderC on 3/7/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncConfig = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _HttpDriver = require('./HttpDriver');

var _FsDriver = require('./FsDriver');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let AsyncConfig = exports.AsyncConfig = function (_AbstractDriver) {
  _inherits(AsyncConfig, _AbstractDriver);

  /**
   * @param {Kernel|*} kernel
   * @param {String} configFile
   */
  function AsyncConfig(kernel) {
    let configFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AsyncConfig.DEFAULT_CONFIG_FILE;

    _classCallCheck(this, AsyncConfig);

    var _this = _possibleConstructorReturn(this, (AsyncConfig.__proto__ || Object.getPrototypeOf(AsyncConfig)).call(this));

    _this._kernel = kernel;
    _this._configFile = configFile;
    return _this;
  }

  /**
   * @returns {Kernel|*}
   */


  _createClass(AsyncConfig, [{
    key: '_load',


    /**
     * @param {String} configFile
     * @private
     */
    value: function _load() {
      let configFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this._configFile = configFile || this._configFile;

      this._kernel.isBackend ? this._loadFromFS() : this._loadFromEndpoint();
    }

    /**
     * @private
     */

  }, {
    key: '_loadFromFS',
    value: function _loadFromFS() {
      let driver = new _FsDriver.FsDriver(this._configFile).inherit(this);

      if (!this._kernel.container.localBackend) {
        let sharedFs = this._kernel.get('fs').shared(this._kernel.rootMicroservice.identifier);

        driver.setFs(sharedFs);
      }

      driver.load();
    }

    /**
     * @private
     */

  }, {
    key: '_loadFromEndpoint',
    value: function _loadFromEndpoint() {
      new _HttpDriver.HttpDriver(this._configFile).inherit(this).load();
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'kernel',
    get: function get() {
      return this._kernel;
    }

    /**
     * @returns {String|*}
     */

  }, {
    key: 'configFile',
    get: function get() {
      return this._configFile;
    }
  }], [{
    key: 'DEFAULT_CONFIG_FILE',
    get: function get() {
      return '_async_config.json';
    }
  }]);

  return AsyncConfig;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Config/Driver/AsyncConfig.js
// module id = 171
// module chunks = 0